import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CategoryForm = ({ 
    category = null, 
    onSubmit, 
    onCancel, 
    loading = false 
}) => {
    const { t } = useTranslation(['inventory', 'common']);
    const [formData, setFormData] = useState({
        name: '',
        description: ''
    });

    useEffect(() => {
        if (category) {
            setFormData({
                name: category.name || '',
                description: category.description || ''
            });
        }
    }, [category]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <form id="category-form" onSubmit={handleSubmit}>
            <div className="form-group">
                <label className="form-label">{t('inventory:name')} *</label>
                <input
                    type="text"
                    className="form-input"
                    value={formData.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                    required
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:description')}</label>
                <textarea
                    className="form-input"
                    value={formData.description}
                    onChange={(e) => handleChange('description', e.target.value)}
                />
            </div>

        </form>
    );
};

export default CategoryForm;